import { RiskLevel } from '@/domain/common/risk'
import { TokenWithBalance } from '@/domain/common/types'
import { IsolatedPairHealthInfo } from '@/features/isolated-details/logic/useIsolatedHealthFactor'
import type {
  Borrow as IsolatedBorrow,
  Deposit as IsolatedDeposit,
} from '@/features/isolated-portfolio/logic/useMyPortfolio'
import type { Borrow as PooledBorrow, Deposit as PooledDeposit } from '@/features/my-portfolio/logic/assets'
import BigNumber from 'bignumber.js'

export interface TokenData {
  supported: {
    evm: TokenWithBalance[]
    l1: TokenWithBalance[]
  }
  otherTokens: {
    evm: TokenWithBalance[]
    l1: TokenWithBalance[]
  }
  totalUSD: string
}

export type GroupedByPairAddress = Record<
  string,
  { deposits: IsolatedDeposit[]; borrows: IsolatedBorrow[]; name: string; healthInfo?: IsolatedPairHealthInfo }
>

export interface PositionData {
  highestRiskLevel: RiskLevel
  pooled: {
    deposits: PooledDeposit[]
    borrows: PooledBorrow[]
    totalUSD: string
    healthFactor?: BigNumber
  }
  isolated: {
    totalUSD: string
    groupedByPairAddress: GroupedByPairAddress
    hasUnsafePositions: boolean
    minHealthFactor?: BigNumber
  }
}

export interface UseAccountOverviewResult {
  tokenData: TokenData
  positionData: PositionData
  totalUSD: string
}

export class BlockSizeError extends Error {
  public details?: Record<string, unknown>

  constructor(message: string, details?: Record<string, unknown>) {
    super(message)
    this.name = 'BlockSizeError'
    this.details = details
  }
}
